import { BasicPermissionItem } from '../../PermissionItem'
import { CreateViewEditRemove, Simple } from '../../common'
import { ConcreteTestingLabs } from '../../../cimsPage/instances/concrete'

const page = ConcreteTestingLabs
const object = 'Testing Lab'

export const ViewTestingLab = Simple({
  id: '723330eb-e3c7-461c-b564-1bebc1bee992',
  page,
  object,
  action: 'View',
})

export const CreateTestingLab = Simple({
  id: 'de297567-d94d-438f-8b92-3b2e0f099f7e',
  page,
  object,
  action: 'Create',
})

const labTech = 'Lab Tech'

export const EditAllTestingLab = new BasicPermissionItem({
  id: 'ab4f0117-d56f-43ac-a954-f18a50b02e5f',
  name: `Edit All ${object}s`,
  page,
  action: `associate ${labTech}s with any ${object}`,
})

export const EditLimitedTestingLab = new BasicPermissionItem({
  id: 'de56e96c-d2c1-4f19-ab58-7d499e104ed0',
  name: `Edit Limited ${object}s`,
  page,
  action: `associate ${labTech}s with any ${object} they are associated with`,
})

export const RemoveTestingLab = Simple({
  id: 'c674af96-61f8-42bd-9d12-8fb93ea1bdbd',
  page,
  object,
  action: 'Remove',
})

const tech = CreateViewEditRemove({
  page,
  object: labTech,
  create: 'a3e95a6f-577f-42fb-8109-3c08673b83a4',
  remove: '95209509-516b-4e14-90ed-8cf700da185d',
  view: '43875429-a339-4b8b-9135-49f764d9e1f0',
  edit: 'ce1e3ac2-b463-4d72-8d6c-b398b55e7b47',
})

export const ViewLabTech = tech.View
export const CreateLabTech = tech.Create
export const RemoveLabTech = tech.Remove
export const EditLabTech = tech.Edit

export type TestingLabPermission =
  | typeof ViewTestingLab
  | typeof CreateTestingLab
  | typeof EditAllTestingLab
  | typeof EditLimitedTestingLab
  | typeof RemoveTestingLab
  | typeof ViewLabTech
  | typeof CreateLabTech
  | typeof RemoveLabTech
  | typeof EditLabTech
